import React, { memo, useEffect, useRef, useState } from 'react';
import { Endpoints, maxPageSize } from '../../../constants';
import smartHttp from '../../../helpers/smartHttp';
import AgGridComponent from '../../../sharedcomponents/ag-grid/AgGrid';

const UserSalesforceEntitlements = memo(({ userContractNumber, emailId }) => {
  const gridApi = useRef(null);
  const [rowData, setRowData] = useState([]);

  const defaultConfig = {
    rowModelType: 'clientSide',
    isExportCSV: false,
    isExportExcel: false,
    pivotPanelShow: '',
    suppressDragLeaveHidesColumns: true,
    pagination: false,
    isAutoSizeColumns: true,
    enableCharts: false,
    rowGroupPanelShow: false,
    sideBar: false,
    overlayNoRowsTemplate: 'This user has no Salesforce entitlements',
  };

  const defaultColdef = {
    sortable: true,
    resizable: true,
    menuTabs: ['generalMenuTab', 'filterMenuTab'],
  };

  const columns = [
    {
      headerName: 'Package',
      headerTooltip: 'Package',
      field: 'packagename',
      tooltipField: 'packagename',
      initialFlex: 3,
    },
    {
      headerName: 'Delivery Platform (Type)',
      headerTooltip: 'Delivery Platform (Type)',
      field: 'deliveryplatform',
      tooltipField: 'deliveryplatform',
      initialFlex: 3,
    },
    {
      headerName: 'Contract ID',
      headerTooltip: 'Contract ID',
      field: 'contractNumber',
      tooltipField: 'contractNumber',
      initialFlex: 2,
    },
    {
      headerName: 'Status',
      headerTooltip: 'Status',
      field: 'pueStatus',
      tooltipField: 'pueStatus',
      initialFlex: 2,
    },
  ];

  const escapeFilterValue = (value = '') => String(value).replace(/"/g, '\\"');

  const onGridReadyHandler = (params) => {
    gridApi.current = params;
    params.api.showLoadingOverlay();
  };

  useEffect(() => {
    const normalizedContracts = (userContractNumber || []).filter(Boolean);
    const normalizedEmail = (emailId || '').trim();

    if (!normalizedContracts.length || !normalizedEmail) {
      setRowData([]);
      if (gridApi.current?.api) {
        gridApi.current.api.showNoRowsOverlay();
      }
      return;
    }

    const contractFilter = normalizedContracts
      .map((num) => `"${num}"`)
      .join(',');
    const emailFilter = escapeFilterValue(normalizedEmail);
    const queryParams = {
      Filter: `contractNumber in (${contractFilter}) AND emailId:"${emailFilter}"`,
      Field: 'packagename,deliveryplatform,contractNumber,pueStatus',
      Sort: 'packagename:asc',
      PageSize: maxPageSize,
      id: String(Date.now()),
    };

    if (gridApi.current?.api) {
      gridApi.current.api.showLoadingOverlay();
    }

    smartHttp
      .getRapid(Endpoints.salesforceEntitlementApi, queryParams)
      .then(({ data }) => {
        const responseRows = (data?.results || []).map((item, index) => ({
          id: index,
          ...item,
        }));
        setRowData(responseRows);

        if (gridApi.current?.api) {
          if (responseRows.length === 0) {
            gridApi.current.api.showNoRowsOverlay();
          } else {
            gridApi.current.api.hideOverlay();
          }
        }
      })
      .catch(() => {
        setRowData([]);
        if (gridApi.current?.api) {
          gridApi.current.api.showNoRowsOverlay();
        }
      });
  }, [emailId, userContractNumber]);

  return (
    <div className="ag-grid-table salesforce-tab-grid">
      <AgGridComponent
        config={defaultConfig}
        defaultColumnDef={defaultColdef}
        data={rowData}
        columns={columns}
        onGridReady={onGridReadyHandler}
      />
      <div className="col-8">
        <span
          title="The entitlements are read-only. For any changes reach out to Energy
        Support."
          className="currently-sub"
        >
          The entitlements are read-only. For any changes reach out to Energy
          Support.
        </span>
      </div>
    </div>
  );
});

export default UserSalesforceEntitlements;
